import Avatar from '@mui/material/Avatar';
import clsx from 'clsx';

export interface UserAvatarUser {
	id?: string | null | undefined;
	userId?: string | null | undefined;
	displayName?: string | null | undefined;
	name?: string | null | undefined;
	username?: string | null | undefined;
	email?: string | null | undefined;
	picture?: string | null | undefined;
	pictureUrl?: string | null | undefined;
}

export interface UserAvatarProps {
	user?: UserAvatarUser | null;
	src?: string | null | undefined;
	alt?: string | null | undefined;
	title?: string | null | undefined;
	size?: 'xs' | 'sm' | 'md';
	className?: string;
}

const SIZE_CLASSES: Record<NonNullable<UserAvatarProps['size']>, string> = {
	xs: 'h-4 w-4 text-[9px]',
	sm: 'h-5 w-5 text-[10px]',
	md: 'h-6 w-6 text-xs',
};

export function UserAvatar({ user, src, alt, title, size = 'sm', className }: UserAvatarProps) {
	const label = normalizeLabel(alt) ?? normalizeLabel(title) ?? getUserLabel(user);
	const tooltip = normalizeLabel(title) ?? label;
	const imageSrc = normalizeLabel(src) ?? normalizeLabel(user?.picture) ?? normalizeLabel(user?.pictureUrl);

	return (
		<Avatar
			src={imageSrc}
			alt={label}
			title={tooltip}
			className={clsx('bg-gray-a4 font-semibold text-gray-a11', SIZE_CLASSES[size], className)}
		>
			{imageSrc === undefined ? getInitials(label) : undefined}
		</Avatar>
	);
}

function getUserLabel(user: UserAvatarUser | null | undefined) {
	return user?.displayName ?? user?.name ?? user?.username ?? user?.email ?? user?.userId ?? user?.id ?? 'Unknown user';
}

function normalizeLabel(label: string | null | undefined) {
	const normalized = label?.trim();
	return normalized ?? undefined;
}

function getInitials(label: string) {
	const normalized = label.trim();
	if (normalized === '') {
		return '?';
	}

	const parts = normalized.split(/[\s._@-]+/).filter(Boolean);
	if (parts.length >= 2) {
		return `${parts[0]![0]}${parts[1]![0]}`.toUpperCase();
	}

	return normalized.slice(0, 2).toUpperCase();
}
